import React, { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FcFinePrint } from "react-icons/fc";
import CarbonEmissionService from "../../../core/service/CarbonEmissionService";
import { LoaderContext } from "../../../App";

const CarbonEmissionDataContainer = ({ t, filter, confirmViewChange, viewToggled }) => {

	const [emissionData, setEmissionData] = useState({});
	const [stats, setStats] = useState({});
	const { loaderDisplay, setLoaderDisplay } = useContext(LoaderContext);

	useEffect(() => {
		if (!filter.emissionTable || !filter.reportingPeriod || !filter.ghgUnit) return;
		getEmissions(filter);
	}, [filter]);
	//handle table False here
	useEffect(() => {
		if (!viewToggled.on) return;

		confirmViewChange(true);
	}, [viewToggled]);

	const getEmissions = (f) => {

		setLoaderDisplay(true);
		CarbonEmissionService.getCategorizedEmissions({
			db: f.emissionTable,
			period: f.reportingPeriod,
			ghgUnit: f.ghgUnit,
			businessUnitIds: f.businessUnits
		}).then(res => {
			setLoaderDisplay(false);
			if (res.status !== 200) return;

			const data = res.data.data;
			const stats = Object.keys(data.stats);
			const emission = {};
			stats?.forEach(stat => {
				emission[stat] = data.emissions?.filter(e => e.scope === stat);
			});
			setEmissionData(emission);
			setStats(data.stats);
		}).catch(err => {
			setLoaderDisplay(false);
		});
	};

	const renderTableHeader = () => {
		const branches = [];
		const keys = Object.keys(emissionData);
		if (keys?.length > 0 && emissionData[keys[0]]?.length > 0) {
			const branchKeys = Object.keys(emissionData[keys[0]][0].branches);
			branchKeys?.forEach(b => {
				if (b === 'total') return;

				branches.push(b);
			});
		}
		return (
			<thead>
				<tr>
					<th className="">{t("Scope.label")}</th>
					<th className="">{t("Source.label")}</th>
					<th className="">{t("OrgTotal.label")} {`(${filter.ghgUnit})`}</th>
					{
						branches?.map(branch => {
							return <th className="">{branch} {`(${filter.ghgUnit})`}</th>;
						})
					}
				</tr>
			</thead>
		);
	};

	const renderEmptyDataLabel = () => {
		return (
			<tr>
				<td colSpan="3" className="text-center">
					<div className="Nodatafound_box">
						<h6><FcFinePrint className="me-2" />{t("Nodatafound.label")}</h6>
					</div>
				</td>
			</tr>
		)
	};
	const sortedScopes = Object.keys(emissionData).sort((a, b) => a.localeCompare(b));
	const renderEmissionRows = (scope, sIndex) => {
		const emissions = emissionData[scope];
		const branchTotal = {};
		const emissionRows = [];
		emissions?.forEach((emission, eIndex) => {
			const branchKeys = Object.keys(emission.branches);
			const branchColumns = [];
			branchKeys?.forEach((branch) => {
				if (branch === 'total') return;
				branchColumns.push(
					<td key={branch}>{emission.branches[branch]}</td>
				);
				if (branchTotal[branch]) {
					branchTotal[branch] += emission.branches[branch] ?? 0;
				} else {
					branchTotal[branch] = emission.branches[branch] ?? 0;
				}
			});
			emissionRows.push(
				<tr key={`emission-${sIndex}-${eIndex}`}>
					<td>{emission.scope}</td>
					<td>{emission.category}</td>
					<td>{emission.branches.total}</td>
					{branchColumns}
				</tr>
			);
		})
		return (
			<>
				{emissionRows}
				{
					stats[scope] > 0 &&
					<tr className='total-row' key={`emissionScopeRow-${sIndex}`}>
						<td>{scope}</td>
						<td>{scope} {t('Total.label')}</td>
						<td>{stats[scope]}</td>
						{
							Object.keys(branchTotal)?.map(branch => {
								return <td>{branchTotal[branch]}</td>;
							})
						}
					</tr>
				}
			</>
		);
	};

	return (
		<div className="card List_table-card01">
			<div id='carbonEmissionTable' className="table-responsive-sm">
				<Table responsive className="m-0">
					{renderTableHeader()}
					<tbody>
						{Object.keys(emissionData)?.length === 0 && renderEmptyDataLabel()}
						{
							Object.keys(emissionData)?.length > 0 &&
							sortedScopes?.map((scope, sIndex) => {
								return renderEmissionRows(scope, sIndex);

							})
						}
					</tbody>
				</Table>
			</div>
		</div>
	);
};

export default withTranslation()(CarbonEmissionDataContainer);
